import React from 'react';
import PropTypes from 'prop-types';

function RouteOverviewTreeRootItem({ nodeDatum, toggleNode, onNodeClick, onNodeMouseOver, onNodeMouseOut, rectSize, focusableNodes }) {
  return (
    <rect
      x="0"
      y={-rectSize / 2}
      width={rectSize}
      height={rectSize}
      onClick={(event) => {
        toggleNode();
        onNodeClick(event, nodeDatum);
      }}
      onKeyPress={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          toggleNode();
          onNodeClick(event, nodeDatum);
        }
      }}
      onMouseOver={onNodeMouseOver}
      onMouseOut={onNodeMouseOut}
      tabIndex={focusableNodes ? 0 : -1}
    />
  );
}

RouteOverviewTreeRootItem.propTypes = {
  nodeDatum: PropTypes.any,
  toggleNode: PropTypes.func,
  onNodeClick: PropTypes.func,
  onNodeMouseOver: PropTypes.func,
  onNodeMouseOut: PropTypes.func,
  rectSize: PropTypes.number,
  focusableNodes: PropTypes.bool,
};

RouteOverviewTreeRootItem.defaultProps = {
  toggleNode: () => null,
  onNodeClick: () => null,
  onNodeMouseOver: () => null,
  onNodeMouseOut: () => null,
  rectSize: 16,
  focusableNodes: true,
};

export default RouteOverviewTreeRootItem;
